






















import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import { SfButton } from '@storefront-ui/vue';
import SvgImage from '~/components/General/SvgImage.vue';

export default defineComponent({
  name: 'AddToWishlist',
  components: {
    SfButton,
    SvgImage,
  },
  props: {
    component: {
      type: String,
      default: 'span',
    },
    isInWishlist: {
      type: Boolean,
      default: false,
    },
    wishlistIcon: {
      type: String,
      default: 'heart',
    },
    isInWishlistIcon: {
      type: String,
      default: 'heart_fill',
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['addToWishlist'],
  setup(props, { emit }) {
    const isLoading = ref(false);
    const actionText = computed(() => {
        if (props.isInWishlist) {
          return (isLoading.value) ? 'Removing from Wishlist' : 'Remove from Wishlist';
        } else {
          return (isLoading.value) ? 'Adding to Wishlist' : 'Add to Wishlist';
        }
    });
    const addToWishlist = () => {
      isLoading.value = true;
      emit('addToWishlist');
    }
    return {
      actionText,
      isLoading,
      addToWishlist
    };
  },
  watch: {
      isInWishlist: {
        handler(newVal) {
          this.isLoading = false;
        },
      },
    },
});
